/*
 * File: NotFound.js
 * Project: mp-mobile-app
 *
 * Created by Cole on 06/04/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: A component for rendering a 404-style view indicating the given URL was invalid.
 */

import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { DefaultLink } from "./DefaultRedirect";
const useStyles = makeStyles(theme => ({
  title: {
    color: "#000",
    fontSize: "2.5em",
    fontWeight: 100,
    lineHeight: 1,
    marginBottom: 20
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  button: {
    color: theme.palette.common.white,
    background: theme.palette.common.buttonGradient,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  },
  spacer: {
    height: "10%"
  }
}));

const NotFound = () => {
  const classes = useStyles();
  return (
    <div className={`gradient padding ${classes.container}`}>
      <Typography className={classes.title} variant="h6">
        Page not found
      </Typography>
      <div className={classes.spacer} />
      <DefaultLink>
        <Button className={classes.button}>Home</Button>
      </DefaultLink>
    </div>
  );
};

export default NotFound;
